import './Announcement.css';
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { CloseOutlined } from '@ant-design/icons';

const ANNOUNCEMENT_DISMISS_KEY_LOCALSTORAGE = 'news-closed';

const getIsVisibleFromLocalStorage = (messageId) => {
  if (
    !window.localStorage ||
    !window.localStorage.getItem(ANNOUNCEMENT_DISMISS_KEY_LOCALSTORAGE)
  ) {
    return true;
  }
  const itemsRead = window.localStorage
    .getItem(ANNOUNCEMENT_DISMISS_KEY_LOCALSTORAGE)
    .split('|');
  return !itemsRead.includes(messageId);
};

const setReadToLocalStorage = (messageId) => {
  if (!window.localStorage) {
    return;
  }
  const items = window.localStorage.getItem(
    ANNOUNCEMENT_DISMISS_KEY_LOCALSTORAGE
  );
  window.localStorage.setItem(
    ANNOUNCEMENT_DISMISS_KEY_LOCALSTORAGE,
    items ? `${items}|${messageId}` : messageId
  );
};

const Announcement = ({ messageId, message }) => {
  const [isVisible, setIsVisible] = React.useState(
    getIsVisibleFromLocalStorage(messageId)
  );
  const onClose = () => {
    setIsVisible(false);
    setReadToLocalStorage(messageId);
  };
  if (!message) {
    return null;
  }
  return isVisible ? (
    <div id="Announcement">
      <div className="message">{message}</div>
      <div className="close-btn">
        <CloseOutlined onClick={onClose} />
      </div>
    </div>
  ) : null;
};

Announcement.propTypes = {
  message: PropTypes.string,
  messageId: PropTypes.string,
};

Announcement.defaultProps = {};

Announcement.displayName = 'Announcement';

export const mapStateToProps = () => ({
  message: '',
  messageId: '',
});

export default connect(mapStateToProps)(Announcement);
